import { useQuery } from "@tanstack/react-query";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { fetchStudentAttendance } from "@/api/students";
import { QueryState } from "@/components/common/AsyncState";
import { StatusChip } from "@/components/common/StatusChip";
import { ATTENDANCE_STATUS_LABELS } from "@/types/enums";

export function StudentLessonsTab({ studentId }: { studentId: string }) {
  const { data: records, isLoading, error } = useQuery({
    queryKey: ["student-attendance", studentId],
    queryFn: () => fetchStudentAttendance(studentId),
  });

  const gradeSeries = (records ?? [])
    .filter((r) => r.grade !== null && r.grade !== undefined)
    .map((r, index) => ({ index: index + 1, grade: r.grade }));

  return (
    <QueryState isLoading={isLoading} error={error}>
      {gradeSeries.length > 0 && (
        <Stack mb={3}>
          <Typography variant="subtitle2" mb={1}>
            Динамика оценок
          </Typography>
          <ResponsiveContainer width="100%" height={180}>
            <LineChart data={gradeSeries}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="index" hide />
              <YAxis domain={[1, 10]} allowDecimals={false} />
              <Tooltip />
              <Line type="monotone" dataKey="grade" stroke="#2E5AAC" strokeWidth={2} dot />
            </LineChart>
          </ResponsiveContainer>
        </Stack>
      )}
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Посещаемость</TableCell>
            <TableCell>Оценка</TableCell>
            <TableCell>ДЗ сдано</TableCell>
            <TableCell>Комментарий преподавателя</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(records ?? []).map((record) => (
            <TableRow key={record.id}>
              <TableCell>
                <StatusChip label={ATTENDANCE_STATUS_LABELS[record.status]} />
              </TableCell>
              <TableCell>{record.grade ?? "—"}</TableCell>
              <TableCell>{record.homeworkDone === null || record.homeworkDone === undefined ? "—" : record.homeworkDone ? "Да" : "Нет"}</TableCell>
              <TableCell>{record.comment || "—"}</TableCell>
            </TableRow>
          ))}
          {(records ?? []).length === 0 && (
            <TableRow>
              <TableCell colSpan={4} align="center">
                Записей об уроках пока нет.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </QueryState>
  );
}
